import axios from 'axios';

const apiUrlAddrSearchAddress = '/api/addresses?term=';
const apiUrlAddrGetAddressDetails = '/api/addresses/';
const apiUrlAddrAddressValidation2 = '/api/addresses/addressValidation2?address=';

const addressService = {
  searchAddress: async (request, searchUrl) =>
    await axios.get(`${searchUrl}${request}` || `${apiUrlAddrSearchAddress}${request}`),
  getAddressDetails: async (request, addressDetailUrl) =>
    await axios.post(addressDetailUrl || `${apiUrlAddrGetAddressDetails}`, request),
  getAddressDetailsById: async (addressId, addressDetailUrl) =>
    await axios.post(`${addressDetailUrl}`, { moniker: addressId }),
  validateAddress: async (request, validationUrl, apiKeyName) =>
    await axios.get(
      `${validationUrl}${request}` || `${apiUrlAddrAddressValidation2}${request}`,
      apiKeyName && {
        headers: {
          APIKeyName: apiKeyName,
        },
      }
    ),
};

export default addressService;
